import { useEffect, useState } from "react";
import { useUser } from "@clerk/react";
import OnboardingComponent from "../components/account/onboardingComponent";
import DashboardHomeComponent from "../components/dashboard/dashboardHomeComponent";
import { DashboardContext } from "../context/DashboardContext";
import { fetchClientData } from "../models/dashboardHelpers";

export default function Dashboard() {
    const { user, isLoaded } = useUser();
    const [clientID, setClientID] = useState(null);
    const [clientData, setClientData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (isLoaded && !user) {
            setLoading(false);
            window.open("/auth/signup", "_self")
        }
        if (!isLoaded || !user) return;
        setClientID(user.id);
        fetchClientData(user.id)
            .then(setClientData)
            .catch(() => setClientData(null))
            .finally(() => setLoading(false));
    }, [isLoaded, user]);

    if (!isLoaded || loading) return null;

    return (
        <DashboardContext.Provider value={{ clientID: clientID, clientData: clientData}}>
            {clientData ? <DashboardHomeComponent /> : <OnboardingComponent />}
        </DashboardContext.Provider>
    );
}